import { render, staticRenderFns } from "./StructureEditor.vue?vue&type=template&id=aa128bdc&scoped=true"
import script from "./StructureEditor.vue?vue&type=script&lang=js"
export * from "./StructureEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa128bdc",
  null
  
)

export default component.exports